class ScrollUpButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.#scrollToTop.bind(this));
    
    // Add keydown listener for accessibility (Enter or Space)
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.#scrollToTop();
      }
    });

    this.handleScrollBound = this.#handleScroll.bind(this);
  }

  connectedCallback() {
    this.#setupScrollListener();
    // Initial check in case user loaded halfway down
    this.#handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScrollBound);
  }

  #scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  #setupScrollListener() {
    window.addEventListener('scroll', this.handleScrollBound, { passive: true });
  }

  #handleScroll() {
    if (window.scrollY > 300) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }
}

if (!customElements.get('scroll-up-button')) {
  customElements.define('scroll-up-button', ScrollUpButton);
}
